import {useState} from "react";
import {Button, Variant} from "../../../Button";
import {Uppercase} from "../../../../styles/components";
import {FormattedMessage} from "react-intl";
import {ModalSize, SimpleModal} from "../../../SimpleModal";
import QRCode from "../../../../assets/images/ab_qr_code.png";
import * as S from './styles'

export const Support = () => {
  const [show, setShow] = useState(false);
  const showModal = () => setShow(true);
  const closeModal = () => setShow(false);

  return (
    <S.Container>
        <S.LargeScreen>
            <S.Content>
                <div>
                  <S.ImageBlock/>
                </div>
                <S.TextBlock>
                    <div>
                        <S.Title>
                            Нужна помощь?
                        </S.Title>
                        <S.Text>
                            Вы можете обратиться в нашу службу поддержки непосредственно через Teleguard
                        </S.Text>
                    </div>
                    <S.Help>
                        Teleguard ID: SUPPORTRU
                    </S.Help>
                    <Button variant={Variant.Business} onClick={showModal}>
                        <Uppercase>Показать QR-код</Uppercase>
                    </Button>
                </S.TextBlock>
            </S.Content>
        </S.LargeScreen>
        <S.SmallScreen>
            <S.SmallContent>
                <S.Title>Нужна помощь?</S.Title>
                <S.ImageBlock/>
                <S.Text>
                    Вы можете обратиться в нашу службу поддержки непосредственно через Teleguard
                </S.Text>
                <S.ButtonItem>
                    <Button variant={Variant.Business} onClick={showModal}>
                        <Uppercase>Показать QR-код</Uppercase>
                    </Button>
                </S.ButtonItem>
            </S.SmallContent>
        </S.SmallScreen>
        <SimpleModal show={show} close={closeModal} modalSize={ModalSize.small}>
            <S.ModalBody>
                <S.QRCode src={QRCode} alt={'qr code'}/>
                <S.ModalText><FormattedMessage id="aboutSupportTeleGuardId"/></S.ModalText>
            </S.ModalBody>
        </SimpleModal>
    </S.Container>
  )
}